/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { TokenRefreshRequest } from '../types/TokenRefresh';
import type { TokenRefreshResponse } from '../types/TokenRefresh';

export type TokenRefreshCreateRequest = TokenRefreshRequest;
export type TokenRefreshCreateResponse = TokenRefreshResponse;

export type TokenRefreshCreateQuery = {};

/**
 * POST /dmx-server/token/refresh/
 *
 * ```yaml
 * operationId: token_refresh_create
 * description: |-
 *   Takes a refresh type JSON web token and returns an access type JSON web
 *   token if the refresh token is valid.
 * tags:
 *   - token
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/TokenRefresh'
 *     description: ''
 * ```
 */
export const tokenRefreshCreateOperation = (rest?: TokenRefreshCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/token/refresh/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/token/refresh/' };
  };

/**
 * POST /dmx-server/token/refresh/
 *
 * ```yaml
 * operationId: token_refresh_create
 * description: |-
 *   Takes a refresh type JSON web token and returns an access type JSON web
 *   token if the refresh token is valid.
 * tags:
 *   - token
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/TokenRefresh'
 *   required: true
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/TokenRefresh'
 *     description: ''
 * ```
 */
export const tokenRefreshCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: TokenRefreshCreateQuery;
  request: TokenRefreshRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<TokenRefreshResponse>> => {
  const operation = tokenRefreshCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
